<template>
  <div class="bolg-detail-modular">

    <div class="header-menu-bar-modular">
      <div class="menu-bar">
        <div class="menu-bar-item" v-for="(item, index) in menuBar" :key="index">
          <span class="top-bar-title" @click="toPersonCenter(index)">{{ item.title }}</span>
          <img class="top-bar-icon" v-if="index < menuBar.length - 1" src="../assets/productDetail/top-bar-icon.png"
            alt="">
        </div>
      </div>
    </div>
    <div class="bolg-detail-body-modualr">
      <el-row :gutter="20">
        <el-col :span="16" :xs="24">
          <div class="bolg-detail-info-modualr">
            <div class="bolg-title">
              {{ currLanguage==3?bolgDetailInfo.eng_title:bolgDetailInfo.title }}
            </div>
            <div class="bolg-time-visitors">
              <div class="bolg-time">
                <img class="time-icon" src="../assets/blog/time-icon.png" alt="">
                <span class="bolg-time-title">{{ changeTime(bolgDetailInfo.create_time) }}</span>
              </div>
              <div class="bolg-visitors">
                <img class="view-icon" src="../assets/blog/view-icon.png" alt="">
                <span class="bolg-visitors-title">{{ bolgDetailInfo.click }}</span>
              </div>
            </div>
            <div class="separate-line"></div>
            <div class="bolg-content">
              <div v-html="(currLanguage==1? bolgDetailInfo.detail:bolgDetailInfo.eng_detail)"></div>
            </div>
          </div>
          <div class="bolg-comment-modualr">
            <div class="bolg-comment-title">
              <img class="titel-division-icon" src="../assets/blog/division-icon.png" alt="">
              <span>{{$t("translateText.participatingcommentsText")}}</span>
            </div>
            <div class="bolg-comment-body">
              <el-input class="comment-textarea" placeholder="说两句吧" type="textarea" rows="5"
                v-model="blogCommont"></el-input>
              <div class="submit-comment-modular">
                <div class="login-prompt-title">
                  <span class="login-title" v-if="isLogin != 1" @click="tologin()">{{ $t("translateText.loginText")
                  }}</span>
                </div>
                <div class="submit-modualr">
                  <el-button class="submit-comment-btn" @click="blogComment()">{{
                    $t("translateText.priceIncreasecommentText") }}</el-button>
                </div>
              </div>
            </div>
            <div class="bolg-comment-area-modualr" v-if="blogCommentList.length>0">
              <div class="bolg-comment-area-title">
                <img class="titel-division-icon" src="../assets/blog/division-icon.png" alt="">
                <span>{{ $t("translateText.commentsectionTtxt") }} （{{ blogCommentList.length }}）</span>
              </div>
              <div class="bolg-comment-item" v-for="(item, index) in blogCommentList" :key="index">
                <div class="bolg-comment-item-left">
                  <img class="user-face" :src="item.head_img" alt="">
                </div>
                <div class="bolg-comment-item-right">
                  <div class="user-name">{{ (item.write == '' ? '-' : item.write) }}</div>
                  <div class="bolg-comment-content">{{ item.content }}</div>
                  <div class="bolg-comment-time">{{ changeTime(item.create_time)  }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24">
          <div class="relevant-bolg-modular">
            <div class="relevant-bolg-title">{{ $t("translateText.relatedrlogsText") }}</div>
            <div class="relevant-bolg-line"></div>
            <div class="relevant-bolg-item" v-for="(item, index) in relevantBolgList" :key="index"
              @click="getBlogDetailByabout(item.id)">
              <div class="relevant-bolg-item-left">
                <img class="right-tag-icon" src="../assets/blog/red-right-tag-icon.png" alt="">
              </div>
              <div class="relevant-bolg-item-right">
                <div class="relevant-bolg-item-title">{{ item.title }}</div>
                <div class="relevant-bolg-item-date">{{ changeTime(item.create_time) }}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>
<script>

export default {

  data() {
    return {
      currLanguage:localStorage.getItem("curLanguageType"),
      menuBar: [
        { title: "首页",eng_title:"Home" },
        { title: "博客",eng_title:"Blog" },
        { title: "博客之家" ,eng_title:"Blog home"},
      ],
      bolgDetailInfo: {},//详情信息
      blogCommont: '',
      // 评论列表
      blogCommentList: [
        // {
        //   userFace: 'https://img2.baidu.com/it/u=3638924343,3602065040&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=1000',
        //   userName: '王大伟',
        //   contenr: "好的，动了",
        //   date: '2022-11-11  08:08',
        // },
        // {
        //   userFace: 'https://img2.baidu.com/it/u=3638924343,3602065040&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=1000',
        //   userName: '王大伟',
        //   contenr: "好的，动了",
        //   date: '2022-11-11  08:08',
        // }
      ],
      blogId: '',//博客详情ID
      // 相关博客
      relevantBolgList: [],
      isLogin: 0,//是否登录
    };
  },
  methods: {
    /**
     * 详情
     * @param {*} id 
     */
    getBlogDetailByabout(id) {
      let that = this;
      that.blogId = id;
      that.getBlogDetail()
    },
    /**
     * 获取博客列表
     */
    getBlogDetail() {
      let that = this;
      let data = {
        blog_id: that.blogId
      }
      this.$http.blogDetail(
        data,
        (res) => {
          if (res.ret == 1) {
            // 详情
            that.bolgDetailInfo = res.blogDetail;
            // 评论列表
            that.blogCommentList = res.comment;
            // 相关博客
            that.relevantBolgList = res.otherList;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);

        }
      )
    },

    /**
     * 跳转登录
     */
    tologin() {
      this.$router.push({
        path: "/login",
      });
    },

    /**
     * 提交评论
     */
    blogComment() {
      let that = this;
      if (this.$parent.tipsLogin()) return
      let data = {
        blog_id: that.blogId,
        comment: that.blogCommont
      }
      this.$http.blogComment(
        data,
        (res) => {
          if (res.ret == 1) {
            // b博客详情
            that.getBlogDetail();
            that.blogCommont = '';
            this.$message.warning("提交成功，待审核");
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);

        }
      )
    },

    /**
     * 跳转个人中心
     */
    toPersonCenter(index) {
      if (index == 0) {
        this.$router.push(
          {
            path: '/',
          }
        )
      } else {
        this.$router.push(
          {
            path: '/blogManagement',
          }
        )
      }
    },
        /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
     translateApiData(data, title, type) {
      let that = this;
      let newTextArr = [];

      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      that.languageTranslateByArr(newTextArr, title, type);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, title, type) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, title, type);
        },
        (res) => { }
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, title, type) {
      let that = this;
      data.forEach((v, i) => {
        switch (type) {
          case -1:
            that.menuBar[i][title] = v.translation;
            break;
          default:
            break;
        }
      });
    },
  },
  mounted() {
    let that = this;
    //     isLogin:0-没有登录，1-已经登录
    that.isLogin = localStorage.getItem('isLogin');
    // 博客ID
    that.blogId = that.$route.query.uuid;
    // b博客详情
    that.getBlogDetail();
    that.menuBar[2].title = that.$route.query.name;
    that.translateApiData(that.menuBar, "title", -1) 
    let url = window.location.href
    
    console.log("url",url)
    localStorage.setItem("url",url)
  },
};
</script>


// WEBPACK FOOTER //
// src/view/bolgDeatil.vue